import {all} from 'redux-saga/effects';
import AuthSaga from './AuthSaga';
import BulkSaga from './BulkSaga'
import UserSaga from './UserSaga'
import RoomSaga from './RoomSaga'
import ArtworkSaga from './ArtworkSaga';
import ArtworkViewSaga from './ArtworkViewSaga';
import ArtworkShareSaga from './ArtworkShareSaga';
import TestSaga from './TestSaga';
const combinedSaga = [...AuthSaga,...BulkSaga, ...UserSaga, ...RoomSaga, ...ArtworkSaga, ...ArtworkViewSaga, ...ArtworkShareSaga]

export default function* RootSaga() {
  yield all(combinedSaga);
}